import { SHAPE_TELEMETRY_APPLIED, SHAPE_TELEMETRY_PRUNED } from '../actions/actionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
  case SHAPE_TELEMETRY_APPLIED: {
    const {
      shapeGuid, modelUsed, retryCount, appliedEdges,
    } = action.payload;
    return {
      ...state,
      [shapeGuid]: {
        shapeGuid,
        appliedFromImageAssist: true,
        modelUsed,
        retryCount,
        appliedEdges,
      },
    };
  }

  case SHAPE_TELEMETRY_PRUNED:
    return action.payload;

  default:
    return state;
  }
};
